import React from 'react';
import './getdirection.css';


function GetDirection() {
  return (
    <div className="google_map_container">
      <h3 className='get_direction_heading'>Get Direction</h3> 
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3392.235592344331!2d77.44596580266187!3d9.978188749361927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0713c66be4302b%3A0xbc5ea57c0c239fae!2ssps%20land%20promoters!5e1!3m2!1sen!2sin!4v1646663417908!5m2!1sen!2sin" className="google_map_direction" allowfullscreen='true'  loading="lazy"></iframe>
    </div>
  )
}

export default GetDirection